"use client";
import React from "react";
import dynamic from "next/dynamic";
const DialogPerson = dynamic(() => import("./components/dialog-person"), {
    ssr: false,
    loading: () => <LoadingComponent />,
});
import { usePathname } from "next/navigation";
import { languages } from "@/app/i18n/settings";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";
import ColorStyleContext from "@/lib/providers/color-style-privider";
import { useContext } from "react";
export interface Model {
    id: string;
    name: string;
    imagePreviewUrl: string;
    imagePreviewAlt?: string;
    title: string;
    previewDes: string;
    allDes: string;
    imageUrl: string;
    imageAlt?: string;
    dialogTitle?: string;
    dialogSubtitle?: string;
    enableDialogDetail: boolean;
    dialogBgColor1?: string;
    dialogBgColor2?: string;
    dialogBgColor3?: string;
    dialogBgColor4?: string;
    dialogGradientAngle?: string;
}

const LoadingComponent = () => {
    const pathName = usePathname();
    const lng = languages.find((l) => pathName.startsWith(`/${l}`)) ?? "th";
    let title = lng === "en" ? "read more" : "อ่านต่อ";
    const colorStyle = useContext(ColorStyleContext);
    return (
        <span
            className="font-medium text-sm text-wrap whitespace-pre-line underline cursor-pointer dynamic-color"
            style={
                {
                    "--dynamic-color": colorStyle.link ?? "#009eca",
                    "--dynamic-color-hover": colorStyle.linkHover ?? "#254b7c",
                } as React.CSSProperties
            }>
            {title}
        </span>
    );
};

const HallOfFameListDialogClient = ({ model }: { model: Model }) => {
    const { hasMouseMoved } = useMouseMovement();

    return <>{hasMouseMoved ? <DialogPerson key={model.id} model={model} /> : LoadingComponent()}</>;
};

export default HallOfFameListDialogClient;
